import { SUPER_ADMIN } from 'app/roles';

export default {
  consoleCommandLogs: {
    path: '/consoleCommandLogs',
    name: 'consoleCommandLogs:consoleCommandLogs',
    roles: [SUPER_ADMIN],
  },
};
